import { useSelector } from "react-redux";
import {
  getInspectionResutlBackground,
  getInspectionResutlColor,
  getInspectionResutlSymbol,
} from "../../utils/display-utils";

export default function InspectionResultCell({
  inspection,
  result,
  setOpenModal,
  setInspectionId,
}) {
  const resultSymbolSetting = useSelector(
    (s) => s.app_settings.inspection_display.inspection_result_symbol
  );
  const symbol = getInspectionResutlSymbol(result, resultSymbolSetting);
  const background =
    symbol.length > 0
      ? getInspectionResutlBackground(result, resultSymbolSetting)
      : "";
  const handleShowInspection = () => {
    setInspectionId(inspection?.inspection?.id);
    setOpenModal(true);
  };
  return (
    <div
      style={{
        color: getInspectionResutlColor(result, resultSymbolSetting),
        background: background,
      }}
      className={`text-center w-full h-10 flex justify-center items-center ${
        inspection?.inspection?.id ? "cursor-pointer hover:!bg-[#feec88]" : ""
      }`}
      onClick={
        inspection?.inspection?.id ? () => handleShowInspection() : undefined
      }
    >
      <span>{symbol}</span>
    </div>
  );
}
